import { ScenarioType } from '@/types/scenario';

import { useScenarioStore } from '@/stores/scenario-store';
import { TransferPair } from '@/types/transfer-pair';
import { useFormatters } from '@/utils/formatters/useFormatters';
import { getScenarioPresentation } from '@/utils/scenario-presentation';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ScenarioDetail } from './scenario-detail';
import { ScenarioResume } from './scenario-resume';
import { AnimatedView } from './ui/tw-wrappers';

export function ScenarioCard({ type, data }: { type: ScenarioType; data: TransferPair }) {
  const { t } = useTranslation();
  const { formatCurrency, formatPercentage, formatNumber } = useFormatters();

  const inputs = useScenarioStore(s => s.inputs);

  // Optimización: Solo recalcular la presentación si los inputs relevantes cambian
  const presentation = useMemo(
    () =>
      getScenarioPresentation(type, data, inputs, t, {
        formatCurrency,
        formatPercentage,
        formatNumber,
      }),
    [
      type,
      data,
      inputs.invoicingAmount,
      inputs.invoicingCurrency,
      inputs.invoicingConcept,
      type === 'localPartner' ? inputs.partnerMargin : null,
      t,
      formatCurrency,
      formatPercentage,
      formatNumber,
    ],
  );

  return (
    <AnimatedView className='group' style={[{ width: '100%', gap: 16 }]}>
      <ScenarioDetail presentation={presentation} type={type} modelType='compare' />
      {type !== 'alsoThere' && <ScenarioResume type={type} />}
    </AnimatedView>
  );
}
